import baseRequest from "../_core/baseRequest";

export default {
    getApplicationCounts: params => baseRequest.post("/applications/counts", params),
    getApplications: (type, params) => baseRequest.post(`/applications/${type}/list`, params),
    exportApplications: (type, params) => baseRequest.post(`/applications/${type}/export`, params),
    getApplication: (type, id) => baseRequest.get(`/applications/${type}/${id}`),
    updateApplicationStatus: (type, id, params) =>
        baseRequest.patch(`/applications/${type}/${id}/status`, params),
    addApplicationNote: (type, id, params) =>
        baseRequest.post(`/applications/${type}/${id}/notes`, params)
};
